import { render, staticRenderFns } from "./TargetGoal.vue?vue&type=template&id=5d1d3300&scoped=true"
import script from "./TargetGoal.vue?vue&type=script&lang=js"
export * from "./TargetGoal.vue?vue&type=script&lang=js"
import style0 from "./TargetGoal.vue?vue&type=style&index=0&id=5d1d3300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d3300",
  null
  
)

export default component.exports